<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/teacher/student">My Students</b-breadcrumb-item>
            <b-breadcrumb-item active>{{$route.params.name}}: 
                <span>{{$t('courseHistory.titulo')}}</span>
            </b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card">
            <div class="card-body">
                <div class="back-step mt-0"  @click="backStep">
                    <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                </div>
                <b-row style="margin-bottom:36px;">
                    <b-col class="d-flex align-items-center justify-content-end" style="border-right: 1px solid #b7b8bd;">
                        <h4 class="sub-title d-flex mb-0" style="padding-right: 20px;">
                            <span>{{$t('courseHistory.titulo')}}</span>
                        </h4>
                    </b-col>
                    <b-col> 
                        <div class="sub-title-img name" style="padding-left: 18px;">
                            <b-avatar 
                            :src='urlPhoto'
                            variant="light"
                            ></b-avatar>
                            <div>
                                <span class="link bold">{{$t('courseHistory.linkStudent')}}</span>
                                <p>{{$route.params.name}}</p>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-form inline style="margin-bottom: 22px;">
                    <b-container fluid style="padding: 0px !important;">
                    <b-row cols="12" sm="6">
                        <b-col cols="12" sm="12" md="3" >
                            <b-form-group class="mr-2" label="Courses" id="content-multiselect-course-history">

                            <multiselect 
                                multiselect v-model="value" :options="optionCourses" :multiple="true"
                                :internal-search="false" :clear-on-select="false" :close-on-select="false"
                                :loading="isLoading"
                                @select="selectAll"
                                @input="onChange"
                                @remove="deselect"
                                :limit="countLimit" :limit-text="limitText"

                                placeholder="Select courses" label="name" track-by="id" :preselect-first="false">

                                <template slot="clear" slot-scope="props">
                                    <div class="multiselect__clear" v-if="value.length" @mousedown.prevent.stop="clearAll(props.search)">
                                        <span class="material-icons">close</span>
                                    </div>
                                </template>
                            </multiselect>
        


                            <!--
                                
                                :hide-selected="true"
                                 <CustomSelect
                                    :options="optionsHistoryCourse"
                                    :default="$t('filter.text')"
                                />
                                <b-form-select class="w-100"
                                v-model="selectedHistoryCourse" 
                                :options="optionsHistoryCourse"
                                >
                                    <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                                </b-form-select> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="3">
                            
                            <b-form-group class="mr-2"  label="Status">
                                <CustomSelect
                                    @input="idValueSelectHistoryStateAsigmments"
                                    :options="optionsHistoryState"
                                    value="id"
                                    label="descripcion" 
                                    :default="$t('filter.text')"
                                    @change="getListCourses()"
                                />
                                <!-- <b-form-select class="w-100"
                                v-model="selectedHistoryState" 
                                :options="optionsHistoryState"
                                >
                                    <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                                </b-form-select> -->
                            </b-form-group>
                        </b-col>
                     
                    </b-row>
                  
                </b-container>
                </b-form>
                <b-table hover :items="itemsAssignments"  :busy="isBusy" :fields="fielAssignments" id="tableStudentHistory"
                :show-empty="true" :empty-text="$t('reusables.empty-text')">
                    	<template #table-busy>
						<div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{$t('ClassRequest.Loading')}}...</strong>
						</div>
					</template>
                    <template #cell(state)="data">
                        <div>
                            <p :style="{color:data.value.color}">{{data.value.name}}</p>
                        </div>
                    </template>
                    <template #cell(certificate)="data">
                        <div v-if="data.item.flagApply">
                         
                            <span v-if="data.value.id==1" @click="DonwloadFile(data.value.link)">
                                 <a class="link noBorder mr-2" >
                                    <img src="@/assets/icons/icon-certificate.svg" class="svg">
                                </a>
                            </span>
                            <span v-if="data.value.id==2">
                                  -
                            </span>
                            <span v-if="data.value.id==3" style="color:#B7B8BD">
                                N/A
                            </span>

                           
                        </div>
                        <p v-else style="color:#B7B8BD">N/A</p>
                        <!-- <p v-else-if="data.item.certificate===null" style="color:#B7B8BD">{{data.item.certificate}}</p> -->
                       
                    </template>
                    <template #cell(evaluations)="data">
                        <div v-if="data.item.flagEdited===true">

                           
                                <a class="link noBorder mr-2"   @click="goEvaluationReports(1,data.item)" >
                                   <img src="@/assets/icons/icon-valid-doc.svg" class="svg">
                                </a>
                            
                        </div>
                        <p v-else>-</p>
                    </template>
                    <!-- <template #cell(return)="data">
                      
                        <div v-if="!data.item.flagGroup && (data.item.state.value == 3 || data.item.state.value == 4 )">
                            <div>
                                <b-button class="btn btn-primary">
                                    Quiero retomarlo
                                </b-button>
                            </div>
                           
                        </div>
                    </template> -->
                </b-table>
                <div class="overflow-auto content-pagination">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="table-evaluation"
                    ></b-pagination>
                    {{currentPage}}-{{perPage}} / {{totalRows > 0 ?  totalRows : totalRows-1}}   {{$t('ClassRequest.text.3')}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import * as tools from '@/assets/js/tools.js';
import Multiselect from 'vue-multiselect'
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { getNextClassDate , getCourseColors, getCourseStateName} from '@/assets/js/util.js';
    export default {
        components:{
            CustomSelect,
            'multiselect': Multiselect
        },
        data(){
            return{
                urlPhoto: Constants.IMAGENES.PHOTO_STUDENT_DEFAULT,
                isBusy : false,
                currentPage: 1,
                perPage : 10,
                totalRows:  0,
                isLoading:false,
                value: [],
                countLimit : 3,
                countAllCourses : 6,
                selectedHistoryCourse: null,
                itemSelect :null,
                itemDeselect :null,
                optionCourses: [],
                optionsHistoryCourse: [
                { value: null, text: 'Please select an option' },

                ],
                selectedHistoryState: null,
                optionsHistoryState: [],
                fielAssignments:[
                    {key:'course' , label:this.$t('courseHistory.table-th.course')},
                    {key:'class' , label:this.$t('courseHistory.table-th.class')},
                    {key:'state' , label:this.$t('courseHistory.table-th.state')},
                    {key:'qualification' , label:this.$t('courseHistory.table-th.qualification')},
                    {key:'certificate' , label:this.$t('courseHistory.table-th.certificate')},
                    {key:'evaluations' , label:this.$t('courseHistory.table-th.evaluations'),thStyle:{width:"12%"}},
                    // {key:'return' , label:'',thStyle:{width:"18%"}}
                    ],
                itemsAssignments: [],
            }
        },
        watch: {
            currentPage: {
                handler: function(value) {
                         this.getListCourses();
                }
            },
        
	    },
        created(){
         
            if(this.$route.params.id == undefined){
            this.$router.push({
                    name : 'teacher/student',
                
                }).catch(err => {}); 
            }else{
                  this.getListFilters();
                 this.getListCourses();
            }

           
        },
        mounted(){
            //importante para los iconos, arriba esta la importación ----------------
            this.$nextTick(function () {
                tools.imgToSvg()
            })
        },
        methods:{
            goEvaluationReports(value,item){
                this.$router.push({name : 'teacher-student-evaluations-reports' , params : 
                { 
                    id : value , 
                    registerId : item.id,
                    flagHistory : true,
                    disabledTab : 2 ,//deshabilita report,
                    groupId : this.$route.params.groupId,
                    groupPlanId : item.groupPlanId  , 
                    personStudentId : item.personsStudentId ,
                    nameSubject : item.course, 
                    flagTab : false
                } 
                })
            },
             getListCourses(){
                 this.isBusy = true;
         
                let valueCourses = null;
                if(this.value.length>0){
                    let indexZero = this.value.filter(function(currentValue,index,arr){
                        return currentValue.id == 0
                        
                    });
                      if(indexZero.length>0){
                        valueCourses = null;
                    }else{
                        valueCourses = this.value.map(element =>(element.id))
                    }
                }
            let format_day = "MM/DD/YYYY";
            let body = {
                //this.$store.state.user.personTeacherId
                PersonsStudentId : this.$route.params.id,//this.$store.state.user.personStudentId,
                ListSubjectLevelsIds : valueCourses,
                StateId: this.selectedHistoryState,
                //TypeCertificate : null,
                PersonTeacherId:this.$store.state.user.personTeacherId,
                Page : this.currentPage,
                Size : this.perPage

            }
             this.itemsAssignments = [];
             baseInstanceAxios
                .post(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/ListPersonsSubjectsHistory`,body)
                .then(response => {
                   if(response.data.list){
                        response.data.list.forEach(element => {
                            console.log("element: ",element)
                            let json = {
                                id : element.id,
                                flagGroup : element.flagGroup,
                                groupPlanId : element.groupPlanId,
                                groupRegisterSubjectId : element.groupRegisterSubjectId,
                                personsStudentId : element.personsStudentId,
                                course : element.subjectName,
                                class : element.lastDateSchedule  ? getNextClassDate(element.lastDateSchedule, this.$store.state.user.timeZoneName, this.$moment, format_day) : '-',
                                flagApply : element.flagApply,
                                flagEdited : element.flagEdited,
                                state : {
                                    value : parseInt(element.subjectStateValue),
                                    name :  getCourseStateName(parseInt(element.subjectStateValue)),
                                    color : getCourseColors(parseInt(element.subjectStateValue))
                                },
                                qualification: element.score ? element.strScore : '-',
                                certificate : {
                                    id : element.certificateId,
                                    link : element.fileCertificate,
                                },
                                evaluations : '-',
                                return : true


                            }

                            this.itemsAssignments.push(json);
                        });

                   }
                   this.totalRows = response.data.rows;
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })

                     this.isBusy = false;
                   
                });
        },
       
        idValueSelectHistoryStateAsigmments(event){
            this.selectedHistoryState = event;
        },
            onChange(event){
         
            if(this.itemSelect){
                if(this.itemSelect.id == 0){
                    this.value = [] 
                    for (let item of this.optionCourses) {
                        if (parseInt(item.id) > 0) {
                            this.value.push(item); 
                        } 
                    }   
                    this.value.push(  { name: 'Select all', id: 0 })
                }else{
                    if(this.countAllCourses == this.value.length){
                        this.value.push(
                             { name: 'Select all', id: 0 }
                        )
                    }
                }
            }

            if(this.itemDeselect ){
                if(this.itemDeselect.id == 0){
                     this.value = []
                }else{  
                    let indexAll = null;
                    this.value.filter(function(currentValue,index,arr){
                      
                        if(currentValue.id == 0){
                            indexAll = index
                        }
                    });
                  
                    if(indexAll != null){
                        this.value.splice(indexAll, 1);
                    }

                   
                }
            }



               this.getListCourses();
            },
            deselect(option){
                this.itemSelect =null;
                this.itemDeselect = option
            },
            selectAll(option){
                this.itemDeselect = null;
                this.itemSelect = option
            },
            clearAll () {
                this.value = []
                this.getListCourses();
            },
            limitText (count) {
                return `${this.$t('reusables.and')} ${count} ${this.$t('courseHistory.otherCourses')}`
            },
            getListFilters(){
            let params = {
                idPersonStudent:this.$route.params.id, //235,
                idPersonTeacher:this.$store.state.user.personTeacherId, //235,
            };

            this.optionCourses=[{ name: 'Select all', id: 0 }]
           
            baseInstanceAxios
                .get(`${this.apiURL}/resources/Subjects/ListSubjectsLevelHistoryByPersonStudent`, {params})
                .then(response => {
                
                   if(response.data.entity){
                       this.urlPhoto = response.data.entity.studentPhotoURL;
                       
                       let arrayCourses = response.data.entity.listSubjects

                       arrayCourses.forEach(element => {
                           this.optionCourses.push(
                            {
                                id : element.id,
                                name : element.name
                            }
                           )
                       });
                    
                        if(arrayCourses.length == 0){
                            this.countLimit = 0
                            this.optionCourses = [];
                        }

                        if(arrayCourses.length == 1){
                            this.countLimit = 1
                        }

                        if(arrayCourses.length == 2){
                            this.countLimit = 2
                        }

                     this.countAllCourses = arrayCourses.length;

                      this.optionsHistoryState =  response.data.entity.listStatesSubjects.map(element =>(
                          {
                              id : element.id,
                              descripcion : getCourseStateName(parseInt(element.id)) 
                              //descripcion : element.descripcion
                          }
                      ))

                   }
                });
            },
            backStep(){
                this.$router.go(-1)
            },
            DonwloadFile(fileName){
                let headers = { responseType: "blob"};

                baseInstanceAxios
                .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/DownloadFileCertificate?nameFile=${fileName}`, headers)
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', `${fileName}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(() =>{});
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>